export default class City {
	id: number;     //ид
	name: string;   //название должности
}